import { Button } from "@/components/ui/button";
import { Trash2, Archive, RefreshCw, UserCheck } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useState } from "react";

export function BulkActionBar({ count, actions, onAction, disabled }) {
  const [statusValue, setStatusValue] = useState("");
  const hasSelection = count > 0;

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="bulk-action-bar">
      <span className={`text-xs font-medium tabular-nums ${hasSelection ? "text-indigo-600" : "text-slate-400"}`} data-testid="bulk-count">
        {hasSelection ? `${count} selectionne${count > 1 ? "s" : ""}` : "Aucune sélection"}
      </span>
      <div className="h-4 w-px bg-slate-200 mx-1" />
      {actions.map((a) => {
        if (a.type === "status-select") {
          return (
            <div key={a.key} className="flex items-center gap-1">
              <Select value={statusValue} onValueChange={setStatusValue} disabled={!hasSelection || disabled}>
                <SelectTrigger className="h-7 w-32 text-xs" data-testid="bulk-status-select"><SelectValue placeholder="Statut..." /></SelectTrigger>
                <SelectContent>
                  {a.options.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
                </SelectContent>
              </Select>
              <Button
                variant="outline" size="sm"
                className="h-7 text-xs px-2"
                disabled={!hasSelection || !statusValue || disabled}
                onClick={() => { onAction("status", { status: statusValue }); setStatusValue(""); }}
                data-testid="bulk-status-apply"
              >
                Appliquer
              </Button>
            </div>
          );
        }
        const Icon = a.icon;
        return (
          <Button
            key={a.key}
            variant={a.variant || "outline"}
            size="sm"
            className={`h-7 text-xs gap-1.5 ${a.className || ""}`}
            disabled={!hasSelection || disabled}
            onClick={() => onAction(a.key)}
            data-testid={`bulk-${a.key}`}
          >
            {Icon && <Icon size={13} />}
            {a.label}
          </Button>
        );
      })}
    </div>
  );
}

export function useSelection(items) {
  const [selected, setSelected] = useState(new Set());

  const toggle = (id) => {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleAll = () => {
    const ids = items.map(i => i.id);
    setSelected(prev => prev.size === ids.length ? new Set() : new Set(ids));
  };

  const clear = () => setSelected(new Set());
  const isAllSelected = items.length > 0 && selected.size === items.length;
  const selectedIds = [...selected];

  return { selected, toggle, toggleAll, clear, isAllSelected, selectedIds, count: selected.size };
}
